import React, { useState, useEffect, useContext, useMemo } from "react";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ActionPlansContext from "context/ActionPlansContext";
import ActionContext from "context/ActionContext";
import _ from "lodash";
import useApi from "api/useApi";
import styled from "styled-components";
import UserService from "services/UserService";
import { putAction, getAction, getSite } from "services/ConfigServices";
import {
  energyType,
  engineeringstudyedelementsData,
  targetedenergyList,
  savingstypeData,
} from "variables/lists/action";
import { action as actionVar } from "variables/action";
import {
  MultiselectCheckbox,
  CustomSelect,
  IntInput,
} from "components/Input/Index.js";
//import useActionTable from "../useActionTable.js";

const TableName = styled.div`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useActionTable() {
  const [totalRows, setTotalRows] = useState(0);
  const [isRefetched, setIsRefetched] = useState(false);

  const appContext2 = useContext(ActionContext);
  const { action, setAction } = appContext2;

  const [structureData, setStructureData] = useState([]);

  console.log(structureData);

  const refreshTable = () => {
    setIsRefetched(!isRefetched);
  };

  useEffect(() => {
    let engineeringstudyedelements =
      action.parameters?.impact?.engineeringstudyedelements;
    console.log(
      "engineeringstudyedelements changed to ",
      engineeringstudyedelements
    );

    if (engineeringstudyedelements === "energy") {
      getPatrimoineData();
    } else if (engineeringstudyedelements === "walls") {
      getStructureData("structure.walls.walls");
    } else if (engineeringstudyedelements === "equipments") {
      getEquipmentsData("equipments.equipmentlist");
    } else if (engineeringstudyedelements === "others") {
      setAction((prevState) => ({
        ...prevState,
        parameters: {
          ...prevState.parameters,
          impact: {
            ...prevState.impact,
            engineeringstudyedelements,
            targets: [],
          },
        },
      }));
      setStructureData([]);
    }
  }, [action.parameters?.impact?.engineeringstudyedelements]);
  const getPatrimoineData = async (event) => {
    let targets = action.parameters?.impact?.energy || [];

    let targetsIds = targets.map((equipment) => {
      return equipment.id;
    });
    setStructureData([
      ...targetedenergyList.filter((obj) => !targetsIds.includes(obj.id)),
      ...targets,
    ]);
  };

  const getStructureData = async (route) => {
    let data = [];
    await axios
      .get(getSite(action.parameters.general.groups[0], route), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        data = res?.data?.detail?.structure?.walls?.walls || [];
      });

    console.log(data);
    filteringData(data, "walls");
  };

  const getEquipmentsData = async (route, parametre) => {
    let data = [];
    await axios
      .get(getSite(action.parameters.general.groups[0], route), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        data = res?.data?.detail?.equipments?.equipmentlist || [];
      });

    console.log(data);
    filteringData(data, "equipments");
  };

  function filteringData(data, target) {
    const allowed = ["name", "uuid"];

    const filteredData = [];
    data.map((wall) => {
      const filteredObj = _.pick(wall, allowed);
      filteredData.push(filteredObj);
    });

    const newKeys = { uuid: "id" };

    const replacedUuidWithIdName = [];

    filteredData.map((wall) => {
      const renamedObj = renameKeys(wall, newKeys);
      replacedUuidWithIdName.push(renamedObj);
    });

    console.log(replacedUuidWithIdName);

    let targets = action.parameters?.impact?.[target] || [];

    let targetsIds = targets.map((x) => {
      return x.id;
    });

    console.log(targets);

    setStructureData([
      ...replacedUuidWithIdName.filter((obj) => !targetsIds.includes(obj.id)),
      ...targets,
    ]);
  }

  function renameKeys(obj, newKeys) {
    const keyValues = Object.keys(obj).map((key) => {
      const newKey = newKeys[key] || key;
      return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
  }

  // ----------------------------------------------------------

  const SubHeaderComponent = () => {
    let engineeringstudyedelements =
      action.parameters?.impact?.engineeringstudyedelements || "";
    let listName =
      engineeringstudyedelementsData.find(
        (x) => x.id == engineeringstudyedelements
      )?.name || "";
    return (
      <>
        <TableName>Sélection des {listName}</TableName>
      </>
    );
  };

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  return {
    gridState: {
      defaultPageSize: 10,
      data: structureData,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: <SubHeaderComponent />,
      //onChangeRowsPerPage: handlePerRowsChange,
      //onChangePage: handlePageChange,
      //onSort: handleSort,
    },
    refreshTable,
  };
}
